import React, { Fragment } from 'react'
import { Form, Input, Radio, Typography } from 'antd'
import PropTypes from 'prop-types'

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
}

const telOperatorLabel = (
  <Typography.Text style={{ fontSize: '18px' }}>
    <span style={{ color: '#d60202' }}>*</span>4. Qual a sua operadora?
  </Typography.Text>
)

const telLabel = (
  <Typography.Text style={{ fontSize: '18px' }}>
    <span style={{ color: '#d60202' }}>*</span>5. Nos informe o DDD + Celular
    para liberação da Recarga. Se atente ao enviar os dados corretamente, se
    houver erros poderá demorar na liberação do seu pedido da sua conta Level Up
  </Typography.Text>
)

export const RecargaCelular = ({ handleChange, answers }) => {
  return (
    <Fragment>
      <Form.Item name='celNumber' label={telLabel}>
        <Input
          type='text'
          name='celNumber'
          value={answers?.celNumber}
          onChange={handleChange('celNumber')}
          required
        />
      </Form.Item>
      <Form.Item label={telOperatorLabel}>
        <Radio.Group onChange={handleChange('celOperator')}>
          <Radio style={radioStyle} value={'TIM'}>
            <Typography.Text style={{ fontSize: '18px' }}>TIM</Typography.Text>
          </Radio>
          <Radio style={radioStyle} value={'OI'}>
            <Typography.Text style={{ fontSize: '18px' }}>OI</Typography.Text>
          </Radio>
          <Radio style={radioStyle} value={'VIVO'}>
            <Typography.Text style={{ fontSize: '18px' }}>VIVO</Typography.Text>
          </Radio>
          <Radio style={radioStyle} value={'CLARO'}>
            <Typography.Text style={{ fontSize: '18px' }}>
              CLARO
            </Typography.Text>
          </Radio>
        </Radio.Group>
      </Form.Item>
    </Fragment>
  )
}

RecargaCelular.propTypes = {
  handleChange: PropTypes.func,
  answers: PropTypes.any,
}
